export default "/images/0f68bbee6f12b7aa951a7feee3a502f2.avif";